const config = {
    env: 'local',
    // apiUrl: "http://localhost:5570/lab-admin/",
    apiUrl: "https://api.docsaab.health/lab-admin/"
    // apiUrl: "http://13.235.246.243:5585/lab-admin/"
}

export default config;
